import react, { createContext } from "react";

export const ExamDetails = createContext({});
export const ExamData = createContext({});
export const MappingData = createContext({});
export const ResponsesData = createContext({});

export const SelectedQuestion = createContext({});
